<template>
    <div class="tp-def-form">
        <div class="h-panel-bar">
            <span class="h-panel-title">{{form.id ? '编辑' : '新增'}}数据模型</span>
        </div>
        <div class="h-panel-body">
            <Form :label-width="100" mode="block">
                <FormItem label="数据模型名称" required>
                    <Input v-model="form.name" placeholder="请输入数据模型名称"/>
                </FormItem>
                <FormItem label="识别码">
                    <Input v-model="form.code" placeholder="可选"/>
                </FormItem>
                <FormItem label="显示位置" required>
                    <NumberInput v-model="form.pos" :min="0" placeholder="数字越大显示越靠前"/>
                </FormItem>
                <FormItem label="状态" required>
                    <Radio v-model="form.enabled" :datas="[{title:'已启用',key:true},{title:'已禁用',key:false}]"/>
                </FormItem>
                <FormItem label="数据模型描述">
                    <Textarea v-model="form.description" :rows="2" placeholder="请输入数据模型描述"/>
                </FormItem>
            </Form>

            <div class="tp-sub-title">
                <span>数据列</span>
                <Button size="xs" @click="addRow">新增一行</Button>
            </div>
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:150px">显示名称</th>
                    <th style="width:140px">字段名称</th>
                    <th style="width:120px">字段类型</th>
                    <th style="width:180px">描述</th>
                    <th style="width:70px">必要信息</th>
                    <th style="width:70px">唯一标识</th>
                    <th style="width:70px">期间标识</th>
                    <th style="width:160px">关联辅助核算</th>
                    <th style="width:120px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(f, i) in form.dataFields" :key="i">
                    <td><Input v-model="f.displayName" placeholder="请输入显示名称"/></td>
                    <td><Input v-model="f.fieldName" placeholder="小写字母"/></td>
                    <td>
                        <Select v-model="f.fieldType" :datas="fieldTypes" :deletable="false" @change="onTypeChange(f)"/>
                    </td>
                    <td><Input v-model="f.description" placeholder="请输入描述"/></td>
                    <td align="center"><Checkbox v-model="f.required"/></td>
                    <td align="center"><Checkbox v-model="f.primaryKey" @change="onPrimaryChange(f)"/></td>
                    <td align="center"><Checkbox v-model="f.period" :disabled="f.fieldType !== 'DATE'" @change="onPeriodChange(f)"/></td>
                    <td>
                        <Select v-model="f.categoryTypeId" :datas="categoryOptions" keyName="id" titleName="name" placeholder="请选择"/>
                    </td>
                    <td class="actions">
                        <span @click="moveUp(i)">上移</span>
                        <span @click="moveDown(i)">下移</span>
                        <span @click="copyRow(i)">复制</span>
                        <span @click="removeRow(i)">删除</span>
                    </td>
                </tr>
                <tr v-if="!form.dataFields.length">
                    <td colspan="9" class="text-center" style="padding:15px">暂无数据列</td>
                </tr>
                </tbody>
            </table>
            <div class="tp-tip">
                提示：字段名称为小写字母且不要有空格；至少有一个唯一标识列和一个期间字段（必须为日期类型）。
            </div>
        </div>
        <div class="h-panel-bar text-right">
            <Button @click="$emit('close')">取消</Button>
            <Button color="primary" @click="save">保存</Button>
        </div>
    </div>
</template>

<script>
    const FIELD_TYPES = [
        {title: '字符串', key: 'STRING'},
        {title: '数字', key: 'NUMBER'},
        {title: '日期', key: 'DATE'}
    ];

    export default {
        name: "TripartiteDefinitionForm",
        props: {
            entity: Object
        },
        data() {
            return {
                form: {id: null, name: '', code: '', pos: 0, enabled: true, description: '', dataFields: []},
                fieldTypes: FIELD_TYPES,
                categories: []
            };
        },
        computed: {
            categoryOptions() {
                let opts = [{id: null, name: '无'}];
                return opts.concat(this.categories);
            }
        },
        methods: {
            init() {
                let e = this.entity;
                this.form = {
                    id: e ? e.id : null,
                    name: e ? e.name : '',
                    code: e ? e.code : '',
                    pos: e ? (e.pos || 0) : 0,
                    enabled: e ? e.enabled !== false : true,
                    description: e ? (e.description || '') : '',
                    dataFields: e && e.dataFields && e.dataFields.length
                        ? JSON.parse(JSON.stringify(e.dataFields))
                        : [this.newRow('code', '编码', 'STRING', true, false),
                            this.newRow('voucherDate', '日期', 'DATE', false, true),
                            this.newRow('category', '类型', 'STRING', false, false),
                            this.newRow('amount', '金额', 'NUMBER', false, false)]
                };
            },
            newRow(fieldName, displayName, fieldType, primaryKey, period) {
                return {
                    displayName: displayName || '',
                    fieldName: fieldName || '',
                    fieldType: fieldType || 'STRING',
                    description: '',
                    required: false,
                    primaryKey: !!primaryKey,
                    period: !!period,
                    categoryTypeId: null
                };
            },
            addRow() {
                this.form.dataFields.push(this.newRow('', '', 'STRING', false, false));
            },
            copyRow(i) {
                let copy = Object.assign({}, this.form.dataFields[i], {fieldName: '', primaryKey: false, period: false});
                this.form.dataFields.splice(i + 1, 0, copy);
            },
            removeRow(i) {
                if (this.form.dataFields.length <= 1) {
                    this.$Message('至少保留一个数据列');
                    return;
                }
                this.form.dataFields.splice(i, 1);
            },
            moveUp(i) {
                if (i === 0) {
                    return;
                }
                let arr = this.form.dataFields;
                let t = arr[i - 1];
                arr[i - 1] = arr[i];
                arr[i] = t;
                this.$forceUpdate();
            },
            moveDown(i) {
                let arr = this.form.dataFields;
                if (i >= arr.length - 1) {
                    return;
                }
                let t = arr[i + 1];
                arr[i + 1] = arr[i];
                arr[i] = t;
                this.$forceUpdate();
            },
            onTypeChange(f) {
                if (f.fieldType !== 'DATE') {
                    f.period = false;
                }
            },
            onPrimaryChange(f) {
                if (f.primaryKey) {
                    this.form.dataFields.forEach(x => {
                        if (x !== f) {
                            x.primaryKey = false;
                        }
                    });
                }
                this.$forceUpdate();
            },
            onPeriodChange(f) {
                if (f.period) {
                    this.form.dataFields.forEach(x => {
                        if (x !== f) {
                            x.period = false;
                        }
                    });
                }
                this.$forceUpdate();
            },
            validate() {
                let fields = this.form.dataFields;
                if (fields.length < 4) {
                    this.$Message('至少保留四个数据列');
                    return false;
                }
                for (let i = 0; i < fields.length; i++) {
                    let f = fields[i];
                    if (!f.displayName || !f.displayName.trim()) {
                        this.$Message(`第${i + 1}行的「显示名称」不能为空`);
                        return false;
                    }
                    if (!f.fieldName || !f.fieldName.trim()) {
                        this.$Message(`第${i + 1}行的「字段名称」不能为空`);
                        return false;
                    }
                    if (/\s/.test(f.fieldName)) {
                        this.$Message(`第${i + 1}行的「字段名称」不要有空格`);
                        return false;
                    }
                }
                let names = fields.map(f => f.fieldName);
                if (new Set(names).size !== names.length) {
                    this.$Message('数据列的字段名称不能重复');
                    return false;
                }
                let primary = fields.filter(f => f.primaryKey);
                if (primary.length > 1) {
                    this.$Message('只能有一个数据列作为唯一标识');
                    return false;
                }
                if (primary.length === 0) {
                    this.$Message('至少有一个数据列作为唯一标识');
                    return false;
                }
                let periods = fields.filter(f => f.period);
                if (periods.length === 0) {
                    this.$Message('至少有一个数据列作为期间字段');
                    return false;
                }
                if (periods.some(f => f.fieldType !== 'DATE')) {
                    this.$Message('期间字段必须是日期类型');
                    return false;
                }
                let cats = fields.filter(f => f.categoryTypeId).map(f => f.categoryTypeId);
                if (new Set(cats).size !== cats.length) {
                    this.$Message('不能有相同的关联辅助核算');
                    return false;
                }
                if (!this.form.name || !this.form.name.trim()) {
                    this.$Message('请输入数据模型名称');
                    return false;
                }
                return true;
            },
            save() {
                if (!this.validate()) {
                    return;
                }
                let p = JSON.parse(JSON.stringify(this.form));
                let req = p.id ? this.$api.tripartite.definition.update(p) : this.$api.tripartite.definition.save(p);
                req.then(() => {
                    this.$Message('保存成功');
                    this.$emit('success');
                });
            },
            loadCategories() {
                this.$api.setting.accountingCategory.list().then(({data}) => {
                    this.categories = (data || []).filter(c => c.categoryType !== 'CASH_FLOW');
                });
            }
        },
        watch: {
            entity() {
                this.init();
            }
        },
        mounted() {
            this.init();
            this.loadCategories();
        }
    };
</script>

<style lang="less" scoped>
    .tp-def-form {
        display: flex;
        flex-direction: column;
        height: 100%;

        .h-panel-body {
            flex: 1;
            overflow: auto;
        }
    }

    .tp-sub-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0;
        font-weight: bold;
    }

    .actions span {
        color: @primary-color;
        cursor: pointer;
        margin-right: 6px;
    }

    .tp-tip {
        color: @dark2-color;
        font-size: 12px;
        margin-top: 10px;
    }
</style>
